import { SideMenu } from '../models/side-menu';

export function menuGeneric(): SideMenu[] {
  return [
    new SideMenu(
      '/dashboard/today',
      'MENU.DASHBOARD',
      false,
      'icon icon-home',
      ['ROLE_HOME']
    ),
    new SideMenu(
      '/dashboard/performence',
      'MENU.PERFORMENCE',
      false,
      'pi pi-fast-forward'
    ),
    new SideMenu(
      '/dashboard/settings',
      'MENU.SETTINGS',
      false,
      'pi pi-history'
    ),
    new SideMenu('/dashboard/help', 'MENU.HELP', false, 'pi pi-money-bill'),

    // new SideMenu('/referentiel', 'MENU.REFERENTIEL', false, 'icon icon-file-description', ['ROLE_REFERENTIEL_CONSULTATION'])
  ];
}
